import WebLayout from "../../../layouts/web";
import Footer from "../../../layouts/web/_components/footer";
import Hero from "./_components/hero";
import RegisterForm from "./_components/register-form";

export default function Registration() {
  return (
    <WebLayout>
      <Hero />
      <RegisterForm />
      <Footer />
    </WebLayout>
  );
}
